import React, { useState } from "react";

const Calculator = () => {
  const [amount, setAmount] = useState(10000);
  const [duration, setDuration] = useState(5);
  const interestRate = 0.04;

  const monthlyRepayment = ((amount * (1 + interestRate)) / duration).toFixed(
    2
  );
  const totalRepayment = (monthlyRepayment * duration).toFixed(2);

  return (
    <div className="font-serif p-6 rounded-md shadow-sm">
      <div className="mb-6">
        <div className="flex justify-between mb-2 text-sm font-medium text-gray-700">
          <span>KES 10,000</span>
          <span>KES {amount.toLocaleString()}</span>
          <span className="text-amber-500">KES 5,000,000</span>
        </div>
        <input
          type="range"
          min={10000}
          max={5000000}
          step={10000}
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
          className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer"
        />
      </div>

      <div className="mb-4">
        <div className="flex justify-between mb-2 text-sm font-medium text-gray-700">
          <span>1 Month</span>
          <span>{duration} Months</span>
          <span className="text-amber-500">12 Months</span>
        </div>
        <input
          type="range"
          min={1}
          max={12}
          value={duration}
          onChange={(e) => setDuration(Number(e.target.value))}
          className="w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-amber-500"
        />
      </div>

      <div className="mt-6 text-sm">
        <p className="text-gray-600">
          Your repayments are{" "}
          <span className="font-semibold text-amber-500">
            KES {Number(monthlyRepayment).toLocaleString()}
          </span>{" "}
          every Month at <span className="text-amber-500">4%</span>
        </p>
        <p className="mt-2 text-lg font-semibold text-gray-800">
          Total you will Pay:{" "}
          <span className="text-amber-500">
            KES {Number(totalRepayment).toLocaleString()}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Calculator;
